import { createContext } from 'react';

const UploadProgressBarContext = createContext({});

export default UploadProgressBarContext;
